import React, { HTMLAttributes } from 'react';
import { joinMultipleStyle } from '../../Utils/ScssUtils';
import { CustomImgType } from './CustomImg';
import './ImgStyle.scss';

export function createCustomImg(
    { className, ...props }: HTMLAttributes<HTMLImageElement>,
    type?: CustomImgType
): React.ReactElement {
    switch (type) {
        case 'iconSmall':
            return (
                <img
                    draggable="false"
                    className={joinMultipleStyle('imgIconSmall', className)}
                    {...props}
                />
            );
        case 'icon':
            return (
                <img
                    draggable="false"
                    className={joinMultipleStyle('imgIcon', className)}
                    {...props}
                />
            );
        case 'iconMedium':
            return (
                <img
                    draggable="false"
                    className={joinMultipleStyle('imgIconMedium', className)}
                    {...props}
                />
            );
        case 'iconMediumLarge':
            return (
                <img
                    draggable="false"
                    className={joinMultipleStyle(
                        'imgIconMediumLarge',
                        className
                    )}
                    {...props}
                />
            );
        case 'iconLarge':
            return (
                <img
                    draggable="false"
                    className={joinMultipleStyle('imgIconLarge', className)}
                    {...props}
                />
            );
        case 'small':
            return (
                <img
                    draggable="false"
                    className={joinMultipleStyle('imgSmall', className)}
                    {...props}
                />
            );
        case 'mediumSmall':
            return (
                <img
                    draggable="false"
                    className={joinMultipleStyle('imgMediumSmall', className)}
                    {...props}
                />
            );
        case 'medium':
            return (
                <img
                    draggable="false"
                    className={joinMultipleStyle('imgMedium', className)}
                    {...props}
                />
            );
        case 'large':
            return (
                <img
                    draggable="false"
                    className={joinMultipleStyle('imgLarge', className)}
                    {...props}
                />
            );
        case 'fullwidth':
            return (
                <img
                    draggable="false"
                    className={joinMultipleStyle('imgFullWidth', className)}
                    {...props}
                />
            );
        default: {
            return <img className={className} {...props} />;
        }
    }
}
